// extracted by mini-css-extract-plugin
export default {"errorFallback":"ErrorFallback-module__errorFallback__eq0uT","lightIcon":"ErrorFallback-module__lightIcon__Xv60p","lightText":"ErrorFallback-module__lightText__2Qs7J"};